<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      titulo="Empresas inquilinas"
      icono="mdi-vector-square"
      tabla-vista="empinq"
      busqueda-rapida
      titulo-crud="empresa inquilina"
      permitir-anadir
      permitir-modificar
      permitir-eliminar
      :filtro-registros="filtroRegistros"
      :key="filtroRegistros"        
      :evento-antes-guardar-formulario-datos="antesGuardarFormularioDatos"
      :evento-antes-abrir-formulario-datos="antesAbrirFormularioDatos"
    >

      <template v-slot:item.nom="{ item }">
        <img v-if="item.urllog" :src="item.urllog" style="max-height: 30px; width: auto; max-width: 150px; margin: 2px 0px -7px 0px" />
        <span v-else style="font-weight: 300">{{ item.nom }}</span>
      </template>

    </TablaDatosAPI>        


  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI-tabs.vue";
import CONSTANTES_CRUD from "@/constantesCRUD"

export default {
  components: { TablaDatosAPI },
  
  computed: {
    filtroRegistros () {
      console.log('filtroRegistros');
      let filtro = "1=1";
      console.log(this.$store.state.operador.instalacion.id_ins);

      /* se aplica un filtro para mostrar las empresas inquilinas de la instalacion 
         a la que pertenece el usuario logado. Si se trata de un Administrador Equinsa 
         no hay filtrado */
      if (null != this.$store.state.operador.instalacion.id_ins)   
        filtro += " AND id_ins = " + this.$store.state.operador.instalacion.id_ins; 



      return filtro;
    }, // fin filtroRegistros

  }, // fin computed

  methods: {
    antesGuardarFormularioDatos: function(accionCRUD, registro) {
      console.log('antesguardarFormularioDatos');

      if (accionCRUD == CONSTANTES_CRUD.ACCION.CREATE) {
        console.log('CRUD.ACCION.CREATE');
        registro.id_ins = this.$store.state.operador.instalacion.id_ins;
      }
    }, // fin metodo  antesGuardarFormularioDatos
    
    antesAbrirFormularioDatos: function(formularioDatos) {
      console.log('antesAbrir');
      console.log(formularioDatos);
     
      formularioDatos.descuentosVinculables = JSON.parse(localStorage.getItem ('descuentos_vinculables'));
      formularioDatos.seleccionados = [];
      formularioDatos.tab = 0;

      if (null != formularioDatos.datosRegistro['desper']){
        try {
          // descuentos almacenados en la base de datos
          var descuentosPermitidosBD = JSON.parse(formularioDatos.datosRegistro['desper']);

          var descuentosPermitidos = [];
          for (var indice in descuentosPermitidosBD) {
            /* busca el id-descuento almacenado en la base de datos en el array de descuentos 
               vinculables recibidos del parking */
            const resultado = formularioDatos.descuentosVinculables.find( 
                                  descuento => descuento.id === descuentosPermitidosBD[indice].id
                              );

            if (undefined != resultado){
              // existe el id
              if ((resultado.descripcion == descuentosPermitidosBD[indice].descripcion) &&
                  (resultado.type == descuentosPermitidosBD[indice].type) &&
                  (resultado.value == descuentosPermitidosBD[indice].value)){
                // es el mismo descuento
                descuentosPermitidos.push(descuentosPermitidosBD[indice]);   
              } else {
                console.log('El descuento difiere');         
                console.log(resultado);
                console.log(descuentosPermitidosBD[indice]);       
              }
            }
            
          }

          if (descuentosPermitidos.length != descuentosPermitidosBD.length){
            alert('Alguno de los descuentos que estaban permitidos ya no existen en el parking. Revise la configuración.')
          }
          // traslado al formulario que descuentos estan permitidos
          formularioDatos.seleccionados = descuentosPermitidos;


          /* Eleccion del descuento favorito. 
             Solo puede seleccionarse como favorito uno de los descuentos permitidos a la 
             empresa inquilina. */
          
          /* creo un array con la descripcion de los descuentos permitidos */
          var descripcionDescuentos = ['Ninguno'];
          for (var indice2 in formularioDatos.seleccionados) {
            descripcionDescuentos.push(formularioDatos.seleccionados[indice2].descripcion);
          }
          // traslado al formulario las descripciones de descuentos permitidos y el favorito actual
          formularioDatos.descripcionDescuentos = descripcionDescuentos;
          formularioDatos.favorito = formularioDatos.datosRegistro['desdesfav'];

        } catch(e) {
           formularioDatos.seleccionados = [];
        }        
      }

    }, // fin metodo  antesAbrir

  }, // fin methods

};
</script>

<style>
</style>